import { Controller } from "@hotwired/stimulus"
import { applyPlatformKeys } from "../helpers/platform_keys"

// The shortcut dialog of a position grid's toolbar (position_grid/_shortcuts_dialog), opened by
// dialog-opener; its keys are spelled the way the platform does (helpers/platform_keys).
export default class extends Controller {
  connect() {
    applyPlatformKeys(this.element)
    // A <dialog> restored from Turbo's cache keeps `open` but not its modal top layer.
    if (this.element.open) this.close()
  }

  // A structure command's answer replaces the whole grid, this dialog with it — removed while
  // open, it never fires `close`, and the page would stay locked.
  disconnect() {
    if (this.element.open) this.released()
  }

  close() {
    this.element.close()
  }

  // A click on the backdrop lands on the dialog element itself.
  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  // dialog-opener locks the page's scroll while the dialog is open; Esc closes it natively too.
  released() {
    document.body.style.overflow = ""
  }
}
